import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import { Signal } from '@interco/inter-ui/components/Signal'

import { SignalFeedbackContainer } from '../styles/SignalFeedback.styles'
import { TSignalFeedbackContent } from '../types/SignalFeedback.types'

export const SignalFeedbackView: FC<TSignalFeedbackContent> = ({
  icon,
  title,
  details,
  intensity,
  type,
  strongDetails = '',
}) => (
  <SignalFeedbackContainer>
    <Signal icon={icon} intensity={intensity} theme={type} />
    {title && (
      <Text variant="headline-h2" color="typography" colorWeight={500} bold>
        {title}
      </Text>
    )}
    {details && (
      <Text variant="body-3" color="typography">
        {details}
        {strongDetails && <strong>{` ${strongDetails}`}</strong>}
      </Text>
    )}
  </SignalFeedbackContainer>
)
